<template>
    <v-dialog
        v-model="confirmExitDialog"
        persistent
        max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="floatright"
                color="warning"
                dark
                v-bind="attrs"
                v-on="on"
            >
                Cancel
            </v-btn>
    </template>
    <v-card>
        <v-card-title class="headline">
        
        </v-card-title>
        <v-card-text>Are you sure you want to exit?</v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="confirmExitDialog = false"
                >
                    No
                </v-btn>
                <v-btn
                    color="green darken-1"
                    text
                    @click="$emit('click')"
                >
                    Yes
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ExitWizardButton',
    props: ['changeTab'],
    data: () => ({
         confirmExitDialog: false
    }),
    methods: {
    }
}
</script>


// WEBPACK FOOTER //
// src/components/customwidgets/ExitWizardButton.vue